<template>
    <div class="timeline-item">
        <div class="timeline-item__content">
            <div class="timeline-item__inner">
                <div class="timeline-item__period">
                    {{ period }}
                </div>
                <div class="timeline-item__text">
                    <slot></slot>
                </div>
            </div>
            <div v-if="image" class="timeline-item__image">
                <img :src="image" alt="">
            </div>
            <a
                v-if="bottomImage"
                :style="{ 'background-image': `url(${bottomImage})` }"
                class="timeline-item__bottom-image"
                @click="prepareVideoPopup"
            />

        </div>
    </div>
</template>
<script>
export default {
    name: 'tl-item',
    props: {
        image: String,
        period: String,
        bottomImage: String,
        bottomVideo: String,
        videoTitle: String
    },
    methods: {
        prepareVideoPopup () {
            if (!this.bottomVideo) return

            const data = {
                id: 'timelineVideoModal',
                src: this.bottomVideo || '',
                poster: this.bottomImage || '',
                title: this.videoTitle || ''
            }
            this.$root.$bus.$emit('open-modal', data)
        }
    }
}
</script>

<style lang="scss">
.timeline-item {
    &__inner {
        @include padding-level(top, S);
        @include padding-level(right, XS);
        @include padding-level(bottom, S);
        @include padding-level(left, XS);
        max-width: 430px;
    }

    &__period {
        margin-bottom: $token-spacers-s;
        display: flex;
        align-items: center;
        gap: $token-spacers-2-xs;
        font-size: 12px;
        font-weight: 700;
        color: $token-colors-gray-30;
        letter-spacing: 1.2px;
        text-transform: uppercase;

        &:after {
            content: '';
            height: 1px;
            flex: 1 1;
            background: $token-colors-gray-30;
            opacity: 0.2;
        }
    }

    &__text {
        & > * {
            &:not(:last-child) {
                margin-bottom: $token-spacers-s;
            }
        }

        & img {
            max-height: 104px;
        }

        & p {
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: 130%;
            color: $token-colors-gray-60;
            letter-spacing: -0.12px;
        }

        & ul:not(.z-list) {
            & li {
                position: relative;
                padding-left: 24px;
                list-style: none;
                font-size: 20px;
                font-style: normal;
                font-weight: 400;
                line-height: 120%;

                &:before {
                    content: '';
                    position: absolute;
                    top: 7px;
                    left: 0;
                    width: 7px;
                    height: 7px;
                    background: #0177C8;
                    border-radius: 50%;
                }
            }
        }

        & .z-list .z-list-item {
            padding-left: 24px;
            & + .z-list-item {
                margin-top: 12px;
            }

            &:before {
                left: 0;
            }
        }
    }

    &__bottom-image {
        position: relative;
        margin-top: 16px;
        max-width: 370px;
        max-height: 370px;
        display: block;
        aspect-ratio: 1/1;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        overflow: hidden;
        cursor: pointer;

        &:before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 74px;
            height: 74px;
            background-image: url("data:image/svg+xml,%3Csvg width='101' height='100' viewBox='0 0 101 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle opacity='0.8' cx='50.0215' cy='50' r='50' fill='%23004C97'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M35.6074 28.6605C35.6074 27.0782 37.3579 26.1225 38.6889 26.9781L69.986 47.0977C71.2107 47.885 71.2107 49.6751 69.986 50.4624L38.6889 70.582C37.3579 71.4376 35.6074 70.4819 35.6074 68.8996V28.6605ZM68.9045 48.7801L37.6074 28.6605V68.8996L68.9045 48.7801Z' fill='white'/%3E%3C/svg%3E%0A");
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            transform: translate(-50%, -50%);
            z-index: 1;

        }
    }

    &__image {
        margin-left: $token-spacers-xs;
        max-width: 495px;
        overflow: hidden;

        @include breakpoint (v-tablet) {
            margin-left: $token-spacers-2-xs;
        }

        & img {
            max-width: 100%;
            border-radius: 0 60px;
        }
    }
}
</style>
